import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import Toggle from "../../components/Toggle";
import Invoice from "../../assets/images/Invoice2.png";
import InvoiceTwo from "../../assets/images/Invoice-two.png";
import InvoiceThree from "../../assets/images/Invoice-three.png";
import { useNavigate, useParams } from "react-router-dom";
import { fetchInvoiceData } from "../../services/invoice";

const PaymentInvoice = () => {
  const [data, setData] = useState({});
  const [maxLength, setMaxLength] = useState(30);
  const [imgSrc, setImgSrc] = useState(null);
  const navigate = useNavigate();
  const { code } = useParams();

  const getInvoiceData = useCallback(async () => {
    try {
      const res = await fetchInvoiceData(code);
      setData(res.data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  }, [code]);

  useEffect(() => {
    getInvoiceData();
  }, [getInvoiceData]);

  useEffect(() => {
    if (data?.invoiceType === 1) {
      setImgSrc(Invoice);
    } else if (data?.invoiceType === 2) {
      setImgSrc(InvoiceTwo);
    } else {
      setImgSrc(InvoiceThree);
    }
  }, [data?.invoiceType]);

  useEffect(() => {
    const updateMaxLength = () => {
      if (window.matchMedia("(min-width: 1280px)").matches) {
        setMaxLength(50); // Desktop screens (xl and above)
      } else {
        setMaxLength(30); // Mobile screens
      }
    };

    updateMaxLength(); // Initialize on mount
    window.addEventListener("resize", updateMaxLength);

    return () => {
      window.removeEventListener("resize", updateMaxLength);
    };
  }, []);

  const copyToClipboard = (textToCopy) => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch((err) => {
        toast.error("Unable to copy to clipboard. Please try again.");
        console.error("Copy to clipboard failed:", err);
      });
  };

  const handleCopyToClipboard = (textToCopy) => {
    copyToClipboard(textToCopy);
  };

  const handleBack = () => {
    navigate("/payments/digital-invoice");
  };

  return (
    <div className="lg:max-w-full max-w-[90%] overflow-hidden">
      <div className="xl:flex xl:items-center xl:justify-between mb-4">
        <h1 className="text-2xl font-bold text-navy-blue">Payments - Links</h1>
        <Toggle />
      </div>

      <section className="bg-white md:max-w-full max-w-[95%] px-8 py-6 h-full flex flex-col">
        <div className="border border-gray-200 md:max-w-full justify-between max-w-72 rounded-t-[10px] p-[1rem] pl-7 flex  items-center mb-8">
          <p className="flex justify-center gap-2 items-center text-green-600 text-xl font-semibold">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_4474_11607)">
                <path
                  d="M19 0H5.00002C2.23997 0.00332812 0.00332812 2.23997 0 5.00002V19C0.00332812 21.76 2.23997 23.9967 5.00002 24H19C21.76 23.9967 23.9967 21.76 24 19V5.00002C23.9967 2.23997 21.76 0.00332812 19 0ZM20 8.079L10.746 17.333C9.96511 18.1142 8.69878 18.1145 7.91756 17.3336C7.91738 17.3334 7.91719 17.3332 7.917 17.333L3.99998 13.417C3.60867 13.0257 3.60867 12.3913 3.99998 12C4.3913 11.6088 5.0257 11.6087 5.41697 12L9.33295 15.916L18.588 6.66202C18.9793 6.27211 19.6125 6.27323 20.0025 6.6645C20.3924 7.05581 20.3913 7.68909 20 8.079Z"
                  fill="#20A464"
                />
              </g>
              <defs>
                <clipPath id="clip0_4474_11607">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            Your Payment Link is ready to go
          </p>
          <span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.5 6.75L9 11.25L13.5 6.75"
                stroke="#464255"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>

        <div className="font-bold text-4xl flex justify-start">
          Payment Invoice for {data.companyName}{" "}
        </div>

        <section className="xl:flex items-start xl:items-center gap-4 mt-8">
          <button className="bg-gray-100 px-0 xl:px-2 rounded-md xl:w-[442px] h-[50px]">
            {data.paymentInvoiceUrl && data.paymentInvoiceUrl.length > maxLength
              ? `${data.paymentInvoiceUrl.slice(0, maxLength)}...`
              : data.link}
          </button>

          <button
            className="flex items-center w-full xl:w-[211.71px] bg-primary text-white gap-2 py-2 px-4 mt-4 xl:mt-0 rounded-md"
            onClick={() => handleCopyToClipboard(data.paymentInvoiceUrl)}
          >
            <span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_4474_11623)">
                  <path
                    d="M9.8125 13H3.5625C2.734 12.999 1.93972 12.6694 1.35389 12.0836C0.768051 11.4978 0.438492 10.7035 0.4375 9.875L0.4375 3.625C0.438492 2.7965 0.768051 2.00222 1.35389 1.41639C1.93972 0.830551 2.734 0.500992 3.5625 0.5L9.8125 0.5C10.641 0.500992 11.4353 0.830551 12.0211 1.41639C12.6069 2.00222 12.9365 2.7965 12.9375 3.625V9.875C12.9365 10.7035 12.6069 11.4978 12.0211 12.0836C11.4353 12.6694 10.641 12.999 9.8125 13ZM15.4375 12.375V4.25C15.4375 4.08424 15.3717 3.92527 15.2544 3.80806C15.1372 3.69085 14.9783 3.625 14.8125 3.625C14.6467 3.625 14.4878 3.69085 14.3706 3.80806C14.2533 3.92527 14.1875 4.08424 14.1875 4.25V12.375C14.1875 12.8725 13.9895 13.3494 13.6393 13.6997C13.289 14.05 12.8125 14.248 12.3125 14.25H5.1875C5.02174 14.25 4.86277 14.3158 4.74556 14.4331C4.62835 14.5503 4.5625 14.7093 4.5625 14.875C4.5625 15.0408 4.62835 15.1997 4.74556 15.3169C4.86277 15.4342 5.02174 15.5 5.1875 15.5H12.3125C13.1407 15.4987 13.9339 15.1688 14.519 14.5838C15.104 13.9987 15.4338 13.2054 15.4375 12.375Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_4474_11623">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>

            <span>Copy link</span>
          </button>

          <a
            href={data.paymentInvoiceFile}
            target="_blank"
            rel="noreferrer"
            download
          >
            <button className="flex items-center w-full xl:w-[211.71px] bg-primary text-white gap-2 py-2 px-4 mt-4 xl:mt-0 rounded-md cursor-pointer">
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_4474_11623)">
                    <path
                      d="M9.8125 13H3.5625C2.734 12.999 1.93972 12.6694 1.35389 12.0836C0.768051 11.4978 0.438492 10.7035 0.4375 9.875L0.4375 3.625C0.438492 2.7965 0.768051 2.00222 1.35389 1.41639C1.93972 0.830551 2.734 0.500992 3.5625 0.5L9.8125 0.5C10.641 0.500992 11.4353 0.830551 12.0211 1.41639C12.6069 2.00222 12.9365 2.7965 12.9375 3.625V9.875C12.9365 10.7035 12.6069 11.4978 12.0211 12.0836C11.4353 12.6694 10.641 12.999 9.8125 13ZM15.4375 12.375V4.25C15.4375 4.08424 15.3717 3.92527 15.2544 3.80806C15.1372 3.69085 14.9783 3.625 14.8125 3.625C14.6467 3.625 14.4878 3.69085 14.3706 3.80806C14.2533 3.92527 14.1875 4.08424 14.1875 4.25V12.375C14.1875 12.8725 13.9895 13.3494 13.6393 13.6997C13.289 14.05 12.8125 14.248 12.3125 14.25H5.1875C5.02174 14.25 4.86277 14.3158 4.74556 14.4331C4.62835 14.5503 4.5625 14.7093 4.5625 14.875C4.5625 15.0408 4.62835 15.1997 4.74556 15.3169C4.86277 15.4342 5.02174 15.5 5.1875 15.5H12.3125C13.1407 15.4987 13.9339 15.1688 14.519 14.5838C15.104 13.9987 15.4338 13.2054 15.4375 12.375Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_4474_11623">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>Download invoice</span>
            </button>
          </a>

          <button className="rounded-md border p-2 border-black py-3">
            <svg
              width="37"
              height="15"
              viewBox="0 0 37 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_4474_11646)">
                <path
                  d="M12.6411 8.75003C13.3315 8.75003 13.8911 8.19038 13.8911 7.50001C13.8911 6.80965 13.3315 6.25 12.6411 6.25C11.9508 6.25 11.3911 6.80965 11.3911 7.50001C11.3911 8.19038 11.9508 8.75003 12.6411 8.75003Z"
                  fill="black"
                />
                <path
                  d="M18.8911 8.75003C19.5815 8.75003 20.1411 8.19038 20.1411 7.50001C20.1411 6.80965 19.5815 6.25 18.8911 6.25C18.2008 6.25 17.6411 6.80965 17.6411 7.50001C17.6411 8.19038 18.2008 8.75003 18.8911 8.75003Z"
                  fill="black"
                />
                <path
                  d="M25.1411 8.75003C25.8315 8.75003 26.3912 8.19038 26.3912 7.50001C26.3912 6.80965 25.8315 6.25 25.1411 6.25C24.4508 6.25 23.8911 6.80965 23.8911 7.50001C23.8911 8.19038 24.4508 8.75003 25.1411 8.75003Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_4474_11646">
                  <rect
                    width="15"
                    height="15"
                    fill="white"
                    transform="translate(11.3911)"
                  />
                </clipPath>
              </defs>
            </svg>
          </button>
        </section>

        <div className="border-b-2 mt-8 pb-2">Invoice Details</div>

        <div className="xl:flex xl:flex-row flex flex-col-reverse gap-4 mt-10 border-b-2 pb-4">
          <section className="flex-[6] flex flex-col gap-4 mt-10">
            <div className="flex justify-between">
              <div>Paid</div>
              <div>{data?.paid === true ? "true" : "false"}</div>
            </div>

            <div className="flex justify-between">
              <div>Customer Name</div>
              <div>{data?.customerName}</div>
            </div>

            <div className="flex justify-between">
              <div>Invoice Date</div>
              <div>
                {" "}
                {new Date(data.invoiceDate).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}{" "}
              </div>
            </div>

            <div className="flex justify-between">
              <div>Due Date</div>
              <div>
                {" "}
                {new Date(data.dueDate).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}{" "}
              </div>
            </div>

            <div className="flex justify-between">
              <div>Currency</div>
              <div>{data.currencyName}</div>
            </div>

            <div className="flex justify-between">
              <div>Payment Invoice Type</div>
              <div>{data?.invoiceType}</div>
            </div>

            <div className="flex justify-between">
              <div>Amount</div>
              <div>{data?.totalAmount}</div>
            </div>

            <div className="flex justify-between">
              <div>Invoice No</div>
              <div>{data?.invoiceNumber}</div>
            </div>
          </section>

          {imgSrc && (
            <div className="flex-[4] ml-8">
              <span>
                <img
                  className="w-[280px] h-[400px]"
                  alt="invoice"
                  src={imgSrc}
                ></img>
              </span>
            </div>
          )}
        </div>

        <div className="mt-12 flex gap-4 justify-start">
          <button
            className="md:w-[142px] w-full text-primary border border-primary p-2 rounded-md"
            onClick={handleBack}
          >
            Back
          </button>

          {/* <button className="md:w-[272px] w-full bg-orange-400 text-white p-2 rounded-md">
            Edit Invoice
          </button> */}
        </div>
      </section>
    </div>
  );
};

export default PaymentInvoice;
